export default __webpack_public_path__ + "81768f9f5c9402a758fefc736e18e8b2.webp";